module.exports = __webpack_public_path__ + "static/welcome_to_elk-e5c5475c4c2f329c285337a3df6458b8.webp";